import { CollectionAsset, getAssetImageUrl } from '@kaltura-ott/tvpil-shared';

import { useCardIconsPaths } from 'components/presenters/Card/hooks/useCardIconsPaths/useCardIconsPaths';
import { SCALING_IMAGE } from 'consts';

interface Props {
  item: CollectionAsset;
  imageType: number | undefined;
  imageHeight: number;
  imageWidth: number;
}

export function useSeriesCatchUpCardImages({ item, imageWidth, imageType, imageHeight }: Props) {
  // getting background image
  const backgroundImageUrl = getAssetImageUrl(item.images, {
    type: imageType,
    width: imageWidth * SCALING_IMAGE,
    height: imageHeight * SCALING_IMAGE,
  });
  const { defaultImage } = useCardIconsPaths({ height: imageHeight, width: imageWidth });

  return {
    height: imageHeight,
    backgroundImageUrl,
    width: imageWidth,
    defaultImageUrl: defaultImage,
  };
}
